export default __webpack_public_path__ + "static/media/Honeywell Intelligrated.fe2772ae.png";